export enum Roles {
  Admin = 1,
  Trader = 2,
  Merchant = 3,
  Client = 4,
}
